export default [
  {
    path: '/_admin',
    name: 'admin',
    redirect: { name: 'admin.manage-products' },
    meta: {
      breadcrumb: 'Administrator',
      menuOptions: {
        title: 'Administration',
      },
    },
    component: {
      render(c) { return c('router-view'); },
    },
    children: [
      {
        path: 'products',
        name: 'admin.manage-products',
        redirect: { name: 'admin.manage-products.search' },
        meta: {
          breadcrumb: 'Items',
          menuOptions: {
            title: 'Items',
            description: 'En esta sección podrá editar o eliminar sus Item',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'admin.manage-products.search',
            meta: {
              breadcrumb: 'Search',
              welcomeAlert: '',
            },
            component: () => import('@/pages/supplier/_admin/manage_products'),
          },
          {
            path: 'create-product/:catalog',
            name: 'admin.create-product',
            meta: {
              breadcrumb() {
                const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                if (!storeInfo) {
                  return 'Item';
                }

                return 'Nuevo Item';
              },
            },
            component: () => import('@/pages/supplier/_admin/create_product'),
          },
          {
            path: 'product/:product',
            name: 'admin.manage-product',
            meta: {
              breadcrumb() {
                const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                if (!storeInfo) {
                  return 'Item';
                }

                return `Item - ${storeInfo.name}`;
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_product'),
          },
        ],
      },
      {
        path: 'users',
        name: 'admin.manage-users',
        redirect: { name: 'admin.manage-users.search' },
        meta: {
          breadcrumb: 'Users',
          menuOptions: {
            title: 'Users',
            description: 'En esta sección podrá editar, activar o bloquear a sus usuarios',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'admin.manage-users.search',
            meta: {
              breadcrumb: 'Search',
            },
            component: () => import('@/pages/supplier/_admin/manage_users'),
          },
          {
            path: 'user/:user',
            name: 'admin.manage-users.edit-user',
            meta: {
              breadcrumb() {
                return 'User';
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_user'),
          },
        ],
      },
      {
        path: 'organizations',
        name: 'admin.manage-organizations',
        redirect() {
          return {
            name: 'admin.manage-organizations.search',
          };
        },
        meta: {
          breadcrumb() {
            return 'Organizations';
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'admin.manage-organizations.search',
            component: () => import('@/pages/supplier/_admin/manage_organizations'),
            meta: {
              breadcrumb() {
                return 'Search';
              },
            },
          },
          {
            path: 'organization/:organization',
            name: 'admin.manage-organizations.edit-organization',
            meta: {
              breadcrumb() {
                return 'Organization';
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_organization'),
          },
        ],
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/router/routes/admin.js